import { createContext } from 'react';
import { InterfaceAcronyms } from '../../interfaces/interfaceAcronyms';

export interface ContextData {
  acronyms: readonly InterfaceAcronyms[] | undefined;
}

export const AcronymsContext = createContext<ContextData>({} as ContextData);
